// extracted by mini-css-extract-plugin
module.exports = {"zoom":"Zoom_zoom__2HRL2","zoomIn":"Zoom_zoomIn__3mjdq","zoomButton":"Zoom_zoomButton__1iytu","zoomDividerLm":"Zoom_zoomDividerLm__3gRL8","zoomOut":"Zoom_zoomOut__18uYH"};